import { z } from 'zod';

import { ZodAmount } from '@Common/types/Amount';

export const ZodSocialContributionComponent = z.enum([
  'canicule',
  'crds',
  'csg',
  'new_solidarity_levy',
  'rsa',
  'social_levy',
  'solidarity_levy',
]);

export type SocialContributionComponent = z.infer<typeof ZodSocialContributionComponent>;

export const ZodSocialLevyTranche = z.enum([
  'csg_97_98',
  'csg_98_05',
  'csg_05_18',
  'csg_18_19',
  'csg_18_nav',
  'csg_19_26',
  'csg_26_nav',
  'csg_ech_nav',
  'ps_98_11a',
  'ps_11a_11b',
  'ps_11b_12',
  'ps_12_13',
  'ps_13_19',
  'ps_18_ech',
  'ps_19_ech',
]);

export type SocialLevyTranche = z.infer<typeof ZodSocialLevyTranche>;

/**
 * `breakdown` and `detailed_taxes_by_social_levy` are cents, and are optional because withdrawals
 * settled before TANG-4051 have neither. They are sparse: a tranche averages 1.64 non-zero entries
 * out of 15, so zeros are omitted rather than stored.
 *
 * They exist for investigation and reconciliation only. Form 2777 declares a total per levy per
 * tranche and never breaks a line down by compartment, so no fiscal consumer reads them.
 */
export const ZodSocialSecurityContributions = z.object({
  rate: z.number(),
  amount: ZodAmount,
  breakdown: z.partialRecord(ZodSocialContributionComponent, z.number().int()).optional(),
  detailed_taxes_by_social_levy: z.partialRecord(ZodSocialLevyTranche, z.number().int()).optional(),
});

export type SocialSecurityContributions = z.infer<typeof ZodSocialSecurityContributions>;
